module.exports = __webpack_public_path__ + "img/address.19c9bf56.svg";